const Discount = () => {
	return (
      <div className="discount">
			Free shipping on orders over £60
      </div>
   );
}
export default Discount;
